import { State } from '../reducers/rootReducer'
import { EntryDataState } from '../reducers/entryDataReducer'

const entryDataSelector = (state: State): EntryDataState => state.entryData

export default entryDataSelector
